export default __webpack_public_path__ + "e10619a3c289c5a4b00d76835ed20aa6.svg";